<template>
  <b-card>
    <h1 class="text-center mb-3">Despesas Operacionais TM</h1>
    <div class="mt-3 rent-info-container">

      <div class="rent-info-box">
        <b-spinner class="loading-charged " v-if="isLoading" variant="primary" small></b-spinner>
        <strong> Aluguel Cobrado: </strong>{{ formatCurrency(rentChargedTmLocal) }}
      </div>

      <div class="rent-info-box">
        <b-spinner class="loading-paid" v-if="isLoading" variant="primary" small></b-spinner>
        <strong> Aluguel Pago: </strong>{{ formatCurrency(rentPaidTmLocal) }}
      </div>

    </div>
    <b-form-group label="Selecione o número do EC">
      <b-form-select
        class="select"
        v-model="selectedKey"
        :options="formattedKeysDataTm"
        @change="applyFilter"
      >
      </b-form-select>
    </b-form-group>
    
    <b-table
      v-if="localFilteredTmData && localFilteredTmData.length > 0"
      :fields="tableFields"
      :items="filteredByEc || localFilteredTmData"
      :per-page="itemsPerPage"
      :current-page="currentPage"
      striped
      hover
      responsive
      class="text-center"
    >
      <template v-slot:cell(date)="row">
        {{ formatDate(row.item.date) }}
      </template>
      <template v-slot:cell(amount)="row">
        {{ formatCurrency(row.item.amount) }}
      </template>
      <template v-slot:cell(fee)="row">
        {{ formatCurrency(row.item.fee) }}
      </template>
      <template v-slot:cell(available)="row">
        {{ formatCurrency(row.item.available) }}
      </template>
      <template v-slot:cell(waitingFunds)="row">
        {{ formatCurrency(row.item.waitingFunds) }}
      </template>
      <template v-slot:cell(balanceAmount)="row">
        {{ formatCurrency(row.item.balanceAmount) }}
      </template>
      <template v-slot:cell(balanceOldAmount)="row">
        {{ formatCurrency(row.item.balanceOldAmount) }}
      </template>
      <template v-slot:cell(netAmount)="row">
        {{ formatCurrency(row.item.netAmount) }}
      </template>
      <template v-slot:cell(paid)="row">
        {{ booleanToString(row.item.paid) }}
      </template>
      <template v-slot:cell(actions)="row">
        <p variant="primary" @click="openModal(row.item.establishmentId)">
          <img class="eye" src="@/assets/images/icons/eye.png" alt="olho" />
        </p>
      </template>
    </b-table>

    <b-pagination
      v-if="localFilteredTmData.length"
      v-model="currentPage"
      :total-rows="localFilteredTmData.length"
      :per-page="itemsPerPage"
      align="center"
      size="md"
      class="mt-3"
    >
    </b-pagination>
    <p v-else class="text-center text-danger">
      Não há Despesas Operacionais TM para este mês.
    </p>
    <TaxTmModal
      @changeLoading="changeLoading"
      :showModal="showModal"
      @update:showModal="showModal = $event"
      :establishmentId="establishmentId"
      :formattedDate="formattedDate"
      @updateRentValues="updateRentValues"
      :selectedKey="selectedKey"
    />
  </b-card>
</template>
<script>
import { BCard, BFormSelect, BTable, BFormGroup, BPagination, BSpinner,} from "bootstrap-vue";
import RentValidator from "./RentValidator";
import TaxTmModal from "./TaxTmModal.vue";

export default {
  props: {
    taxTmData: { type: Array, default: () => [] },
    rentChargedTm: { type: Number, default: 0 },
    rentPaidTm: { type: Number, default: 0 },
    keysDataTm: { type: Array, default: () => [] },
    filteredTmData: { type: Array, default: () => [] },
    formattedDate: { type: String, default: null },
  },
  components: { BCard, BFormSelect, BTable, BFormGroup, BPagination, BSpinner, RentValidator, TaxTmModal,},
  data() {
    return {
      selectedKey: null,
      rentChargedTmLocal: 0,
      rentPaidTmLocal: 0,
      rentChargedBackup: 0,
      rentPaidBackup: 0,
      rentChargedEc: null,
      rentPaidEc: null,
      currentPage: 1,
      itemsPerPage: 8,
      showModal: false,
      establishmentId: null,
      isLoading: false,
      localFilteredTmData: this.filteredTmData,
      filteredByEc: undefined,
      tableFields: [
        { key: "actions", label: "" },
        { key: "establishmentId", label: "EC" },
        { key: "name", label: "Nome" },
        { key: "balanceId", label: "ID do balanço" },
        { key: "type", label: "Tipo" },
        { key: "description", label: "Descrição" },
        { key: "date", label: "Data" },
        { key: "available", label: "Disponível" },
        { key: "waitingFunds", label: "Aguardando Fundos" },
        { key: "balanceOldAmount", label: "Saldo Anterior" },
        { key: "amount", label: "Valor" },
        { key: "fee", label: "Taxa" },
        { key: "netAmount", label: "Valor Líquido" },
        { key: "balanceAmount", label: "Saldo Atual" },
        { key: "paid", label: "Pago" },
      ],
    };
  },
  computed: {
    formattedKeysDataTm() {
      return [
        { value: null, text: "----------------------------------" },
        ...this.keysDataTm.map((key) => ({
          value: key,
          text: `EC ${key}`,
        })),
      ];
    },
  },
  watch: {
    filteredTmData(newVal) {
      this.localFilteredTmData = newVal;
    },
    rentChargedTm(newVal) {
      this.rentChargedTmLocal = newVal;
    },
    rentPaidTm(newVal) {
      this.rentPaidTmLocal = newVal;
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
    formatCurrency(value) {
      if (value === null || value === undefined) return "R$ 0,00";
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
    booleanToString(value) {
      return value ? "SIM" : "NÃO";
    },
    updateRentValues(rentPaidEc) {
      this.rentPaidTmLocal = rentPaidEc.rentPaidEc;
      this.rentChargedTmLocal = rentPaidEc.rentChargedEc;
    },
    changeLoading() {
      this.isLoading = false;
    },
    applyFilter() {
      if (this.selectedKey) {
        this.isLoading = true;
        this.rentChargedBackup = this.rentChargedTm;
        this.rentPaidBackup = this.rentPaidTm;
        const filteredEc = [];
        const filtered = this.localFilteredTmData.filter(
          (item) => item.establishmentId == this.selectedKey
        );
        filteredEc.push(...filtered);
        this.filteredByEc = filteredEc;
        this.establishmentId = filtered[0] ? filtered[0].establishmentId : null;
      } else {
        this.ClearEc();
        this.localFilteredTmData = [...this.taxTmData];
        this.rentChargedTmLocal = this.rentChargedBackup;
        this.rentPaidTmLocal = this.rentPaidBackup;
      }
    },
    ClearEc() {
      this.selectedKey = null;
      this.filteredByEc = undefined;
      this.localFilteredTmData = [...this.taxTmData];
    },
    openModal(establishmentId) {
      this.establishmentId = establishmentId;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
<style scoped >
.rent-info-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.rent-info-box {
  background-color: #f1f1f1;
  padding: 20px;
  min-height: 50px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  flex: 1;
  text-align: center;
  font-size: 1.1rem;
  font-weight: bold;
  color: #333;
  position: relative;
}
.rent-info-box strong {
  font-weight: bold;
}
.loading-charged {
  position: absolute;
  top: 30%;
  left: 25%;
  height: 20px;
  width: 20px;
}
.loading-paid {
  position: absolute;
  top: 30%;
  left: 29%;
  height: 20px;
  width: 20px;
}
.select {
  width: 49%;
}
.eye {
  width: 30px;
}
</style>